<template>
    <b-container class="bg-light mt-4 pb-2" style="min-height: 50vh">
        <h4 class="text-center pt-2">Details</h4>
        <hr class="w-50">
        <b-card no-body>
            
        </b-card>
        <table class="mx-auto table d-print-table table-responsive-sm table-borderless" v-if="institute && course">
            <tr>
                <th><h5>Institute Name:</h5></th>
                <td><h5>{{ institute.name }}</h5></td>
            </tr>
            <tr>
                <th><h5>Qualification Name:</h5></th>
                <td><h5>{{ course.name }}</h5></td>
            </tr>
            <tr>
                <th><h5>Credits:</h5></th>
                <td><h5>{{ course.credits }}</h5></td>
            </tr>
            <tr>
                <th><h5>MNQF Level:</h5></th>
                <td><h5>{{ course.mnqf.level }}</h5></td>
            </tr>
            <tr>
                <th><h5>MNQF Qualification Title:</h5></th>
                <td><h5>{{ course.mnqf.title }}</h5></td>
            </tr>
	    <tr>
		<th><h5>Duration:</h5></th>
		<th><h5>{{ course.duration }}</h5></th>	
	    </tr>
            <tr>
                <th><h5>Modality:</h5></th>
                <td><h5>{{ course.modality }}</h5></td>
            </tr>
            <tr>
                <th><h5>Delivery & Teaching:</h5></th>
                <td><h5>{{ course.delivery }}</h5></td>
            </tr>
            <tr>
                <th>
                    
                </th>
                <td></td>
            </tr>
        </table>
        <button type="button" @click="print" class="btn btn-primary btn-block d-print-none mb-2">Print</button>
        <p class="d-none d-print-block text-center align-self-bottom">{{ 'mqa.gov.mv' + this.$route.path }}</p>
    </b-container>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return{
            institute: null,
            course: null
        }
    },
    methods: {
        getInstitute() {
            let path = this.API_URL + '/institutes/' + this.$route.params.institute_id
            axios.get(path).then((response) => {
                this.institute = response.data
            }, (error) => {
                console.log(error)
            });
        },

        getCourse() {
            let path = this.API_URL + '/courses/' + this.$route.params.course_id
            axios.get(path).then((response) => {
                this.course = response.data
                // // Update page title here because it's dynamic
                // // Otherwise this will fail horribly
                document.title = this.institute.name + ' — ' + this.course.name
            }, (error) => {
                console.log(error)
            });
        },

        print() {
            window.print()
        }
        
    },
    beforeCreate() {
        
    },
    created() {
        
    },
    beforeMount() {
        this.getInstitute()
        this.getCourse()
    },
    mounted() {
        
    },
    beforeUpdate() {
        
    },
    updated() {
        
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/course.vue